import React, { useState } from 'react';

/**
 * Confirmation floating window (Bootstrap modal).
 * onConfirm receives an async function; the buttons are disabled while it runs.
 */
const ConfirmDialog = ({
  title,
  message,
  confirmLabel = 'OK',
  cancelLabel = 'Cancel',
  danger = false,
  onConfirm,
  onCancel,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const handleConfirm = async () => {
    try {
      setSubmitting(true);
      await onConfirm();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div className="modal-backdrop fade show"></div>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog" onMouseDown={onCancel}>
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
          onMouseDown={(e) => e.stopPropagation()}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{title}</h5>
              <button type="button" className="btn-close" aria-label="Close" onClick={onCancel}></button>
            </div>
            <div className="modal-body">{message}</div>
            <div className="modal-footer">
              <button type="button" className="btn btn-gh" onClick={onCancel} disabled={submitting}>
                {cancelLabel}
              </button>
              <button
                type="button"
                className={`btn ${danger ? 'btn-gh-danger' : 'btn-gh-primary'}`}
                onClick={handleConfirm}
                disabled={submitting}
              >
                {submitting ? 'Processing...' : confirmLabel}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmDialog;
